@if (isOpen && mode) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/55 px-4 py-6">
    <article
      class="flex max-h-full w-full max-w-4xl flex-col overflow-hidden rounded-sm border border-slate-300 bg-white shadow-2xl"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title">
      <div class="flex items-center justify-between bg-brand-primary px-3 py-2">
        <div class="flex items-center gap-2">
          @if (mode === 'question-paper') {
            <img [src]="imageEnum.WHITE_FILE" alt="" class="h-4 w-4" />
          }
          <h2 class="text-base font-semibold text-white">{{ title }}</h2>
        </div>

        <button
          type="button"
          class="flex h-5 w-5 items-center justify-center text-lg leading-none text-white transition hover:opacity-80"
          aria-label="Close popup"
          (click)="onClose()">
          x
        </button>
      </div>

      <div class="min-h-0 flex-1 overflow-y-auto">
        @if (mode === 'question-paper') {
          <div class="border-b border-slate-300 bg-slate-50 px-4 py-2.5">
            <p class="label-small-heading font-semibold">{{ popupHeading }}</p>
          </div>

          <div>
            @for (group of questionGroups; track group.label) {
              <section class="question-group">
                <!-- Group header removed as per request -->

                @for (question of group.questions; track question.id) {
                  <section class="question-row">
                    <div class="question-row-number">{{ question.displayNumber }}.</div>
                    <div class="question-row-content question-prompt-html" [innerHTML]="question.prompt | richHtml"></div>
                  </section>
                }
              </section>
            }
          </div>
        } @else {
          <div class="px-5 py-4">
            <p class="instruction-popup-note">Please read the instructions carefully</p>

            <section class="mb-6">
              <h3 class="instruction-section-title">General Instructions:</h3>

              <ol class="instruction-list mt-3 list-decimal">
                @for (item of instructionIntroItems; track item.id; let index = $index) {
                  @if (index < 2) {
                    <li class="instruction-item text-mock-gray-800">{{ item.text }}</li>
                  }
                }
              </ol>

              <div class="mt-4 flex flex-col gap-2 pl-5">
                @for (item of paletteLegend; track item.id) {
                  <div class="instruction-legend-row">
                    <span class="instruction-legend-tile">
                      <span
                        class="instruction-chip"
                        [class.instruction-chip-default]="item.tone === 'slate'"
                        [class.instruction-chip-red]="item.tone === 'red'"
                        [class.instruction-chip-green]="item.tone === 'green'"
                        [class.instruction-chip-purple]="item.tone === 'purple'"
                        [class.instruction-chip-violet]="item.tone === 'violet'">
                        {{ item.count }}

                        @if (item.tone === 'violet') {
                          <span class="instruction-chip-dot" aria-hidden="true"></span>
                        }
                      </span>
                    </span>
                    <p class="instruction-item m-0 text-mock-gray-800">{{ item.label }}</p>
                  </div>
                }
              </div>

              <ol class="instruction-list mt-4 list-decimal" start="3">
                @for (item of instructionIntroItems; track item.id; let index = $index) {
                  @if (index === 2) {
                    <li class="instruction-item text-mock-gray-800">
                      {{ item.text }}
                      @if (item.highlightedText) {
                        <span class="instruction-red-text">{{ item.highlightedText }}</span>
                      }
                    </li>
                  }
                }
              </ol>
            </section>

            @for (section of instructionSections; track section.id) {
              <section class="mb-6 last:mb-0">
                <h3 class="instruction-section-title">{{ section.title }}</h3>

                <ol
                  class="instruction-list mt-3 list-decimal"
                  [attr.start]="getSectionStart(section.id)">
                  @for (item of section.items; track $index; let index = $index) {
                    <li
                      class="instruction-item text-mock-gray-800"
                      [class.instruction-red-text]="
                        section.id === 'parts' || (section.id === 'answering' && index === 0)
                      ">
                      {{ item }}
                    </li>
                  }
                </ol>
              </section>
            }
          </div>
        }
      </div>
    </article>
  </div>
}
